var navigation = new Navigation(document.getElementById("navigation"));

// 點選
// var navigation = new Navigation(document.getElementById("navigation"), {
//     submenuTrigger: "click"
// });
